import {
  createStore,
  combineReducers,
  applyMiddleware,
} from "../../node_modules/redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web

// main screen
import userReducer from "./slices/main-screen/user";
import screenReducer from "./slices/main-screen/render-screen";
import screenLockReducer from "./slices/main-screen/screen-lock";
import modalReducer from "./slices/main-screen/modal";
import warningModalReducer from "./slices/main-screen/warning-modal";

// website
import testerReducer from "./slices/website/tester";
import contactReducer from "./slices/website/contact";
import confirmBookingsReducer from "./slices/website/confirm-booking";
import qrReducer from "./slices/website/qr-handler";
import userbookingsReducer from "./slices/website/userbookings";
import transactionsReducer from "./slices/website/transactions";
import requestDemoSliceReducer from "./slices/website/request-demo";

// assistance bookings
import bookingsHistoryReducer from "./slices/assistance-bookings/bookings-history";
import bookingRequestsTableReducer from "./slices/assistance-bookings/booking-requests-table";
import bookingFormReducer from "./slices/assistance-bookings/booking-form";
import additionalPassengerReducer from "./slices/assistance-bookings/additional-passenger";

// prm bookings
import bookingsReducer from "./slices/prm-bookings/bookings";
import calendarReducer from "./slices/prm-bookings/calendar";
import bookingTableReducer from "./slices/prm-bookings/bookings-table";
import bookingsCountReducer from "./slices/prm-bookings/bookings-count";
import listCountReducer from "./slices/prm-bookings/list-count";
import departuresReducer from "./slices/prm-bookings/departures";
import arrivalsReducer from "./slices/prm-bookings/arrivals";
import filterReducer from "./slices/prm-bookings/filter";
import bookingForecastReducer from "./slices/prm-bookings/booking-forecast";
import beaconsReducer from "./slices/beacons/beacons";
import seasonalVarianceReducer from "./slices/prm-bookings/seasonal-variance"
// prm club
import rewardsReducer from "./slices/prm-club/rewards";
import analyticsReducer from "./slices/prm-club/analytics";

// analytics
import reviewsReducer from "./slices/analytics/reviews";
import newusersReducer from "./slices/analytics/new-users";
import reviewNameReducer from "./slices/analytics/review-name";
import weatherReducer from "./slices/analytics/weather";

// profile
import feedbackReducer from "./slices/profile/feedback";
import airportInformationReducer from "./slices/profile/airport-information";
import adminTableReducer from "./slices/profile/admin-table";
import staffManagementReducer from "./slices/profile/staff-management";

import qa from "./slices/qa/qa";
import notificationsReducer from "./slices/notifications/notifications";
// messaging
import messagingReducer from "./slices/messaging/messaging";

// incidents
import incidentsReducer from "./slices/incidents/incidents";

// archive
import archiveReducer from "./slices/archive/archive";

import flightsReducer from "./slices/prm-bookings/flights";

import userProfileReducer from "./slices/profile/user-profile";
//import loaderReducer, { loadingMiddleware } from "./slices/loader/loader";

import menuContextReducer from "./slices/utils/menu-context";

// flights
import flightInformationReducer from "./slices/flights/flight-information";
import flightSearchReducer from "./slices/flights/flight-search";
import linkedFlightReducer from "./slices/flights/linked-flight";


// timeline
import employeesReducer from "./slices/timeline/employees";
import timelineDataReducer from "./slices/timeline/timeline-data";
import selectedTaskReducer from "./slices/timeline/selected-task";
import timelineAreasReducer from "./slices/timeline/timeline-areas";
import flightScannerReducer from "./slices/timeline/flight-scanner";
import flightInformationListReducer from "./slices/timeline/flight-information-list";
import timelineFlightListReducer from "./slices/timeline/timeline-flight-list";
import timelineBookingsReducer from "./slices/timeline/timeline-bookings";


import timelineControlSlice from "./slices/timeline/timeline-control";
import timelineDashboardSlice from "./slices/timeline/timeline-dashboard"
import timelineLiveLocationTabSlice from "./slices/timeline/timeline-live-location-tab";
import timelineToast from "./slices/timeline/timeline-toast";
import timelineFlightInformationReducer from "./slices/timeline/timeline-flight-information";
import themeReducer from "./slices/timeline/theme"
import selectedEmpoyeeReducer from "./slices/timeline/selected-employee";
import createBreakTaskReducer from "./slices/timeline/create-break-task";
import gateRelocationFormReducer from "./slices/timeline/gate-relocation-form";
import flightSearchDropdownReducer from "./slices/timeline/flight-search-dropdown";
import passengerSearchDropdownReducer from "./slices/timeline/passenger-search-dropdown";
import locationDropdownReducer from "./slices/timeline/location-dropdown";
import selectedLocationReducer from "./slices/timeline/selected-location";

// total reports
import totalReportsReducer from "./slices/total-reports/total-reports";
import reviewControlPanelReducer from "./slices/analytics/review-control-panel";

// timeline reports
import timelineReportsReducer from "./slices/timeline-reports/timeline-reports";
import timelineReportBuilderReducer from "./slices/timeline-report-builder/timeline-report-builder";
import slaReportsReducer from "./slices/sla-reports/sla-reports";
import ecacReportReducer from "./slices/sla-reports/ecac-report";
import externalCallPointReportReducer from "./slices/sla-reports/external-call-point-report";
import movementReportReducer from "./slices/sla-reports/movement-report";
import movementSheetReducer from "./slices/sla-reports/movement-sheet";
import boardingSlaReducer from "./slices/sla-reports/boarding-sla";
import transferSlaReducer from "./slices/sla-reports/transfer-sla";
import inboundSlaReducer from "./slices/sla-reports/inbound-sla";
import inboundKpiReducer from "./slices/sla-reports/inbound-kpi";
import terminalReceptionReducer from "./slices/sla-reports/terminal-reception";
import flightAuditReportReducer from "./slices/sla-reports/flight-audit-report";
import employeeAuditReportReducer from "./slices/sla-reports/employee-audit-report";
import airlinePerformanceReducer from "./slices/sla-reports/airline-performance";
import ecacDepartureSummaryReportReducer from "./slices/sla-reports/ecac-departure-summary-report";
import ecacArrivalSummaryReportReducer from "./slices/sla-reports/ecac-arrival-summary-report";
import arrivalTasksReducer from "./slices/sla-reports/arrival-tasks";

// marketplace
import createProductReducer from './slices/marketplace/create-product';
import transactionReducer from './slices/marketplace/transaction';
import retailerReducer from './slices/marketplace/retailer';

// user marketplace
import userMarketplaceReducer from './slices/marketplace/user-marketplace';
import stripeReducer from './slices/marketplace/stripe';
import userTransactionReducer from './slices/marketplace/user-transaction';
import userMarketplaceProductsReducer from './slices/marketplace/user-marketplace-products';

// live location
import liveLocationReducer from "./slices/timeline/live-location-tab";
import staffEquipmentReducer from "./slices/timeline/staff-equipments";
import rejectReasonsReducer from "./slices/timeline/reject-reasons";

// employee beacons
import employeeBeaconReducer from "./slices/timeline/employee-beacons";

// flight events
import flightEventsReducer from "./slices/timeline/flight-events";

// break tasks
import breakTasksReducer from "./slices/timeline/break-tasks";

// api data
import apiDataReducer from "./slices/api-data/api-data";

// asset tracking
import assetTrackingReducer from "./slices/asset-tracking/asset-tracking";

// security
import securityReducer from "./slices/security/security";


// Nested persist config for timelineBookings � only persist clientDuplicates (not the large bookingsByFlight)
const timelineBookingsPersistConfig = {
  key: 'timelineBookings',
  storage,
  whitelist: ['clientDuplicates'],
};
const persistedTimelineBookingsReducer = persistReducer(timelineBookingsPersistConfig, timelineBookingsReducer);

// Nested persist config for timelineReports � only persist the selected tab, not large report data
const timelineReportsPersistConfig = {
  key: 'timelineReports',
  storage,
  whitelist: ['selectedReportType'],
};
const persistedTimelineReportsReducer = persistReducer(timelineReportsPersistConfig, timelineReportsReducer);


const timelineAreasPersistConfig = {
  key: 'timelineAreas',
  storage,
  whitelist: ['selectedTimeline'],
};
const persistedTimelineAreasReducer = persistReducer(timelineAreasPersistConfig, timelineAreasReducer);

const middleWareEnhancer = applyMiddleware(thunk);

const rootReducer = combineReducers({
  user: userReducer,
  messaging: messagingReducer,
  tester: testerReducer,
  contact: contactReducer,
  rewards: rewardsReducer,
  bookings: bookingsReducer,
  qr: qrReducer,
  screen: screenReducer,
  booking: userbookingsReducer,
  transactions: transactionsReducer,
  confirmBooking: confirmBookingsReducer,
  date: calendarReducer,
  bookingTable: bookingTableReducer,
  modal: modalReducer,
  reviews: reviewsReducer,
  bookingsHistory: bookingsHistoryReducer,
  lock: screenLockReducer,
  warning: warningModalReducer,
  newusers: newusersReducer,
  reviewName: reviewNameReducer,
  count: bookingsCountReducer,
  listCount: listCountReducer,
  departures: departuresReducer,
  arrivals: arrivalsReducer,
  feedback: feedbackReducer,
  beacons: beaconsReducer,
  airportInformation: airportInformationReducer,
  analytics: analyticsReducer,
  filter: filterReducer,
  adminTable: adminTableReducer,
  staffManagement: staffManagementReducer,
  requests: bookingRequestsTableReducer,
  bookingForm: bookingFormReducer,
  bookingForecast: bookingForecastReducer,
  seasonalVariance: seasonalVarianceReducer,
  additionalPassenger: additionalPassengerReducer,
  weather: weatherReducer,
  qa: qa,
  notifications: notificationsReducer,
  incidents: incidentsReducer,
  archive: archiveReducer,

  employees: employeesReducer,
  timelineData: timelineDataReducer,
  menuContext: menuContextReducer,
  selectedTask: selectedTaskReducer,
  timelineAreas: persistedTimelineAreasReducer,
  flightScanner: flightScannerReducer,
  flightInformation: flightInformationReducer,
  flightSearch: flightSearchReducer,
  linkedFlight: linkedFlightReducer,
  flights: flightsReducer,
  totalReports: totalReportsReducer,
  timelineReports: persistedTimelineReportsReducer,
  timelineReportBuilder: timelineReportBuilderReducer,
  slaReports: slaReportsReducer,
  ecacReport: ecacReportReducer,
  externalCallPointReport: externalCallPointReportReducer,
  movementReport: movementReportReducer,
  movementSheet: movementSheetReducer,
  boardingSla: boardingSlaReducer,
  transferSla: transferSlaReducer,
  inboundSla: inboundSlaReducer,
  inboundKpi: inboundKpiReducer,
  terminalReception: terminalReceptionReducer,
  flightAuditReport: flightAuditReportReducer,
  employeeAuditReport: employeeAuditReportReducer,
  airlinePerformance: airlinePerformanceReducer,
  ecacDepartureSummaryReport: ecacDepartureSummaryReportReducer,
  ecacArrivalSummaryReport: ecacArrivalSummaryReportReducer,
  arrivalTasks: arrivalTasksReducer,
  reviewControlPanel: reviewControlPanelReducer,
  flightInformationList: flightInformationListReducer,
  timelineFlightList: timelineFlightListReducer,
  timelineBookings: persistedTimelineBookingsReducer,
  timelineControl: timelineControlSlice,
  timelineDashboard: timelineDashboardSlice,
  timelineLiveLocationTab: timelineLiveLocationTabSlice,
  timelineToast: timelineToast,
  timelineFlightInformation: timelineFlightInformationReducer,
  theme: themeReducer,
  userProfile: userProfileReducer,
  createProduct: createProductReducer,
  transaction: transactionReducer,
  retailer: retailerReducer,

  // marketplace
  userMarketplace: userMarketplaceReducer,
  stripe: stripeReducer,
  userTransaction: userTransactionReducer,
  userMarketplaceProducts: userMarketplaceProductsReducer,

  requestDemo: requestDemoSliceReducer,

  liveLocation: liveLocationReducer,
  staffEquipments: staffEquipmentReducer,
  rejectReasons: rejectReasonsReducer,
  employeeBeacons: employeeBeaconReducer,
  selectedEmployee: selectedEmpoyeeReducer,
  createBreakTask: createBreakTaskReducer,
  gateRelocationForm: gateRelocationFormReducer,
  flightSearchDropdown: flightSearchDropdownReducer,
  passengerSearchDropdown: passengerSearchDropdownReducer,
  locationDropdown: locationDropdownReducer,
  // api data
  apiData: apiDataReducer,

  // asset tracking
  assetTracking: assetTrackingReducer,

  // flight events
  flightEvents: flightEventsReducer,

  // break tasks
  breakTasks: breakTasksReducer,

  // selected location
  selectedLocation: selectedLocationReducer,

  // security
  security: securityReducer,
});

const persistConfig = {
  key: "root",
  storage,
  // Blacklist large reducers that can be refetched from the server
  // These contain large datasets that exceed localStorage quota
  blacklist: [
    "selectedTask",
    "timelineData", // Contains large timeline cache, bookings, task lists - DO NOT PERSIST
    "timelineBookings", // Contains bookingsByFlight dictionary
    "timelineDashboard", // Dashboard data
    "timelineLiveLocationTab", // Live location data
    "bookings", // Large booking datasets
    "bookingTable", // Table data
    "departures", // Flight departure data
    "arrivals", // Flight arrival data
    "timelineFlightList", // Flight list data
    "flightInformationList", // Flight information data
    "bookingsHistory", // Historical booking data
    "totalReports", // Report data
    // "timelineReports" � removed from blacklist; using nested persistReducer to persist selectedReportType only
    "slaReports", // SLA report data - commented out to persist
    "ecacReport", // ECAC report data - commented out to persist
    "externalCallPointReport", // External Call Point report data - clear on refresh
    "movementReport", // Movement report data - commented out to persist
    "movementSheet",
    "boardingSla", // Boarding SLA report data - commented out to persist
    "transferSla", // Transfer SLA report data - commented out to persist
    "inboundSla", // Inbound SLA report data - commented out to persist
    "inboundKpi", // Inbound KPI report data - commented out to persist
    "terminalReception", // Terminal Reception report data - commented out to persist
    "flightAuditReport", // Flight audit report data - clear on refresh
    "employeeAuditReport", // Employee location audit report data - clear on refresh
    "airlinePerformance", // Airline Performance report data - commented out to persist
    "ecacDepartureSummaryReport", // ECAC Departure Summary report data - commented out to persist
    "ecacArrivalSummaryReport", // ECAC Arrival Summary report data - commented out to persist
    "incidents", // Incident data - fetched via onSnapshot
    "archive", // Archive data - fetched via onSnapshot
    "arrivalTasks", // Arrival Tasks report data - clear on refresh
    "apiData", // API cached data
    "liveLocation", // Live location data
    "menuContext", // Menu context data
    "timelineReportBuilder",

    // SIRAN: commented to unlist timelineAreas to persist selectedTimeline
    // "timelineAreas", // Timeline areas data
    "flightEvents", // Flight events data
    "timelineFlightInformation", // Flight passenger list data (fetched on demand)

    // SIRAN: commented to unlist employees to persist emp search
    "employees", // Employee list data - fetched on demand
    "gateRelocationForm", // Form data - no need to persist
    "flightSearchDropdown", // Dropdown state - no need to persist
    "passengerSearchDropdown", // Dropdown state - no need to persist
    "locationDropdown", // Dropdown state - no need to persist
    "selectedLocation", // Selected location - no need to persist
    "createBreakTask",
    "employeeBeacons",
    "linkedFlight",
    "timelineToast",
    "tester",
    "count",
    "timelineAreas",
    "breakTasks",
    "messaging",
    "reviewControlPanel",
    "assetTracking",
    "reviews",
    "requests",
    "adminTable",
    "staffManagement",
    "seasonalVariance",
    "timelineReports",
    "createProduct",
    "confirmBooking",
    "bookingForm",
    "additionalPassenger",
    "flightScanner",
    "flightSearch",
    "flights",
    "flightInformation",
    "security"
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default () => {
  let store = createStore(persistedReducer, middleWareEnhancer);
  let persistor = persistStore(store);
  return { store, persistor };
};

